import React, { FC, Suspense, lazy } from 'react';

import Skeleton from 'crehana-ui/Skeleton';

import { PhoneLeadCardProps } from './types';

const PhoneLeadCard = lazy(
  () =>
    import(
      /* webpackChunkName: "search-landing-phone-lead-card" */ './PhoneLeadCard'
    ),
);

const LazyPhoneLeadCard: FC<PhoneLeadCardProps> = props => (
  <Suspense
    fallback={
      <Skeleton className="w-full h-full rounded-5" isDark={props.isDark} />
    }
  >
    <PhoneLeadCard {...props} />
  </Suspense>
);

export default LazyPhoneLeadCard;
